import { Component } from "@angular/core";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from "@angular/forms";
import { MatCardModule } from "@angular/material/card";
import { MatInputModule } from "@angular/material/input";
import { MatSelectModule } from "@angular/material/select";
import { select, Store } from "@ngrx/store";
import {
  catchError,
  firstValueFrom,
  forkJoin,
  map,
  Observable,
  of,
  Subscription,
  take,
} from "rxjs";
import { AppState } from "../../../app.state";
import {
  selectDespachoEntradas,
  selectDespachosEmpresas,
} from "../../../states/despacho/selector";
import { CommonModule } from "@angular/common";
import {
  selectCatalogoEmpresas,
  selectCatalogoTipoDespacho,
} from "../../../states/catalogos/selector";
import {
  consultarDespachos,
  enviarNotificacionDespacho,
  esNuevoDespacho,
  getEntradasByIdEmpresa,
  getEntradasByIdEmpresaSuccess,
  guardarNuevoDespacho,
  setContador,
} from "../../../states/despacho/actions";
import { MatIconModule } from "@angular/material/icon";
import { MatButtonModule } from "@angular/material/button";
import { IEntrada } from "../../../interfaces/entradas";
import { AcuerdosService } from "../../../services/acuerdos/acuerdos.service";
import {
  IEntradaDespacho,
  INuevoTemaDespacho,
} from "../../../interfaces/despacho";
import { Router, RouterLink } from "@angular/router";
//import { CdkScrollable } from "@angular/cdk/scrolling";
import { MatTooltipModule } from "@angular/material/tooltip";
import { EntregablesService } from "../../../services/entregables/entregables.service";
import { LoadingService } from "../../../loading/loading.service";
import { ConfirmDialogComponent } from "../../../confirm-dialog/confirm-dialog.component";
import { MatDialog } from "@angular/material/dialog";
import { selectUsuario } from "../../../states/usuario/selector";
import { DespachoService } from "../../../services/despacho/despacho.service";
import { UsuarioService } from "../../../usuario/usuario.service";
import { EntradaService } from "../../../entrada/entrada.service";
import { LoadCatalogosService } from "../../../services/catalogos/load-catalogos/load-catalogos.service";
import { sortCatalogo } from "../../../utils";
import { EntradasService } from "../../../services/entradas/entradas.service";
import { TemasService } from "../../../services/temas/temas.service";
import { AcuerdosUtilsService } from "../../acuerdo/utils";

@Component({
  selector: "app-nuevo-despacho",
  standalone: true,
  imports: [
    MatCardModule,
    FormsModule,
    ReactiveFormsModule,
    MatInputModule,
    MatSelectModule,
    CommonModule,
    MatIconModule,
    MatButtonModule,
    RouterLink,
    //CdkScrollable,
    MatTooltipModule,
  ],
  templateUrl: "./nuevo-despacho.component.html",
  styleUrl: "./nuevo-despacho.component.css",
})
export class NuevoDespachoComponent {
  public nuevoDespacho!: FormGroup;
  public despachos$!: Observable<any[]>;
  public tipoDespacho$!: Observable<any>;
  public entradasState: IEntrada[] = [];
  public listaEntradas: IEntrada[] = [];
  private stateEntradas: any = this.store.pipe(select(selectDespachoEntradas));
  private stateUsuario: any = this.store.pipe(select(selectUsuario));
  public mostrarEntradas = false;
  private usuario: any = null;
  public oUsuario: any;
  public catEmpresa: any[] = [];
  public catTipoDespacho: any[] = [];
  public catCategorizacion: any[] = [];
  public catAllCategorizacion: any[] = [];
  private stateUserSubscription = new Subscription();

  constructor(
    private fb: FormBuilder,
    private store: Store<AppState>,
    private acuerdosService: AcuerdosService,
    private entregablesService: EntregablesService,
    private loadingService: LoadingService,
    public dialog: MatDialog,
    public despachoService: DespachoService,
    public usuarioService: UsuarioService,
    public entradaService: EntradaService,
    public loadCatalogosService: LoadCatalogosService,
    public entradasService: EntradasService,
    public temasService: TemasService,
    public acuerdosUtils: AcuerdosUtilsService,
    public router: Router
  ) {
    // this.stateUserSubscription = this.usuarioService
    //   .getUsuario()
    //   .pipe(take(1))
    //   .subscribe((user) => {
    //     this.usuario = user;
    //     console.log(" this.usuario ngOnInit", this.usuario);
    //   });
    //this.despachos$ = this.store.select(selectCatalogoEmpresas).pipe(take(1));
    // this.tipoDespacho$ = this.store
    //   .select(selectCatalogoTipoDespacho)
    //   .pipe(take(1));
  }

  async ngOnInit() {
    // this.entradas$ = this.store.select(selectDespachoEntradas).pipe();
    // this.entradas$.subscribe((entradas) => {
    //   this.listaEntradas = entradas;
    //   console.log("entradas", entradas);
    // });

    //this.listaEntradas = await this.stateEntradas.state().formaEnvio.entradas;
    this.oUsuario = structuredClone(this.stateUsuario.state().usuario);
    this.listaEntradas = [];

    this.nuevoDespacho = this.fb.group({
      nombreTema: [
        "",
        [
          Validators.required,
          Validators.minLength(1),
          Validators.maxLength(1000),
        ],
      ],
      empresa: [{}, Validators.required],
      id_tipo_despacho: ["", Validators.required],
      entradaSelected: [""],
      entradas: [[]],
    });
    this.cargaCatalogos().subscribe((res) => {
      console.log("res", res);
      if (res) {
        this.catEmpresa = res.catEmpresa;
        this.catEmpresa.push({ activo: true, descripcion: "Otro", id: "otro" });
        this.catTipoDespacho = res.catTipoDespacho;
        this.catCategorizacion = this.acuerdosUtils.getCategorizacioCombo(
          res.catCategorizacion
        );
        this.catAllCategorizacion = this.acuerdosUtils.getAllCategorizacion(
          res.catCategorizacion
        );
      }
    });
  }
  ngOnDestroy() {
    if (this.stateUserSubscription) {
      this.stateUserSubscription.unsubscribe();
    }
  }
  desabilitarBusqueda(): boolean {
    const entradas = this.nuevoDespacho.get("entradas") as FormControl;
    return (
      this.listaEntradas.length == 0 ||
      this.listaEntradas.length == entradas.value.length
    );
  }
  async seleccionarEmpresa(empresa: any) {
    const entradas = this.nuevoDespacho.get("entradas") as FormControl;
    entradas.setValue([]);
    //this.store.dispatch(getEntradasByIdEmpresa({ idEmpresa: empresa.id }));

    const temas: any = this.catAllCategorizacion.map((cat) => ({
      id_categorizacion: cat.id,
      id_tipo_forma: 2,
      id_empresa: empresa.id,
    }));
    console.log("temas", temas);
    const entradaSelected = this.nuevoDespacho.get(
      "entradaSelected"
    ) as FormControl;

    const res = await firstValueFrom(
      this.entradasService.obtenerEntradas(temas)
    );
    console.log("res nuevvo despacho", res);

    if (res.error) {
      this.listaEntradas = [];
      this.entradasState = [];
      entradaSelected.disable();
    } else {
      this.listaEntradas = res.entradas;
      this.entradasState = res.entradas;
      entradaSelected.enable();
    }
  }
  async onInput(event: any, temaForm: any) {
    const initialState = this.entradasState;
    console.log("initialState", initialState);

    const entradasActuales = temaForm.get("entradas").value;
    const entradasFiltradas: IEntrada[] = this.filtrarEntradasActuales(
      entradasActuales,
      initialState
    );

    const nombreEntrada = [undefined, null, ""].includes(
      event.target.value.trim()
    )
      ? ""
      : event.target.value.trim();

    if (!nombreEntrada) {
      this.listaEntradas = entradasFiltradas;
    }
    if (nombreEntrada) {
      this.listaEntradas = entradasFiltradas.filter((entrada: IEntrada) => {
        return (
          entrada.nombreEntradaCompleto &&
          entrada.nombreEntradaCompleto
            .toLowerCase()
            .includes(nombreEntrada.toLowerCase())
        );
      });
    }
  }

  onFocus(temaForm: any) {
    this.mostrarEntradas = true;
    this.setEntradasOnFocusOnBlur(temaForm);
  }

  onBlur(temaForm: any) {
    setTimeout(() => {
      this.mostrarEntradas = false;
      this.setEntradasOnFocusOnBlur(temaForm);
    }, 200);
  }

  async setEntradasOnFocusOnBlur(temaForm: any) {
    const initialState = this.entradasState;
    console.log("initialState", initialState);

    const entradasActuales = temaForm.get("entradas").value;
    const entradasFiltradas: IEntrada[] = this.filtrarEntradasActuales(
      entradasActuales,
      initialState
    );

    this.listaEntradas = entradasFiltradas;
  }

  filtrarEntradasActuales(
    entradaControl: IEntrada[],
    orignalState: IEntrada[]
  ) {
    return orignalState.filter((entrada: IEntrada) => {
      // Filtrar las entradas que no existen en entradaControl por idEntrada
      return !entradaControl.some(
        (controlEntrada: IEntrada) =>
          controlEntrada.id_entrada === entrada.id_entrada
      );
    });
  }

  getAllEntradas(listaEntradas: any) {
    return listaEntradas;
  }
  selectEntrada(entrada: any, listaEntradas: any) {
    this.loadingService.show();
    const entradaSelected = this.nuevoDespacho.get(
      "entradaSelected"
    ) as FormControl;

    entradaSelected.setValue("");

    const entradas = this.nuevoDespacho.get("entradas") as FormControl;

    const dataNuevaEntrada: IEntradaDespacho = {
      id_entrada: entrada.id_entrada,
      id_categorizacion: entrada.id_categorizacion,
      id_tema: null,
      indice: null,
      nombreEntrada: entrada.nombreEntrada,
      nombreEntradaCompleto: entrada.nombreEntradaCompleto,
      banConSeguimiento: entrada.banConSeguimiento,
      justificacionSeguimiento: entrada.justificacionSeguimiento,
      banEsActivo: entrada.banEsActivo,
      id_empresa: entrada.id_empresa,
      desc_empresa: entrada.desc_empresa,
      fecha_inicio: entrada.fecha_inicio,
      remitente_descripcion: entrada.remitente_descripcion,
      remitenteCompleto: entrada.remitenteCompleto,
      idSobre: entrada.idSobre,
      documentoSoporte: entrada.documentoSoporte,
      nombre_empresa: entrada.desc_empresa,
      value: entrada.id_entrada,
      entregables: [],
      archivos: [],
      esFront: false,
      puedeVer: false,
    };

    this.acuerdosService
      .getEntregableArchivos(entrada.id_entrada)
      .then((data) => {
        data.subscribe((files) => {
          console.log("files", files);

          dataNuevaEntrada.archivos = files.archivos;
          dataNuevaEntrada.entregables = files.entregables;
          console.log("dataNuevaEntrada", dataNuevaEntrada);
          const nuevasEntradas = [...entradas.value, dataNuevaEntrada];
          entradas.setValue(nuevasEntradas);
          this.mostrarEntradas = false;
          this.loadingService.hide();
        });
      });
  }
  disabled(listaEntradas: any[]): boolean {
    const entradaSelected = this.nuevoDespacho.get(
      "entradaSelected"
    ) as FormControl;
    const entradas = this.nuevoDespacho.get("entradas") as FormControl;

    if (
      listaEntradas.length === 0 ||
      this.nuevoDespacho.get("entradas")?.value.length == listaEntradas.length
    ) {
      entradaSelected.disable();
    } else {
      entradaSelected.enable();
    }

    return (
      entradas.value.length > 0 && entradas.value.length == listaEntradas.length
    );
  }

  async guardarDespacho() {
    this.loadingService.show();

    if (!this.nuevoDespacho.valid) {
      this.loadingService.hide();
      return;
    }

    const data = this.nuevoDespacho.getRawValue();

    const despacho: INuevoTemaDespacho = {
      nombreTema: data.nombreTema,
      id_empresa: data.empresa.id,
      id_tipo_despacho: data.id_tipo_despacho,
      nombre_empresa: data.empresa.descripcion,
      entradas: data.entradas,
    };

    const notificacion = {
      nombreUsuario: this.oUsuario.nombre,
      empresa: data.empresa.descripcion ?? "",
      tipoDespacho: data.id_tipo_despacho == 1 ? "Informativo" : "VoBo",
      nombreTema: despacho.nombreTema,
      descripcionTema: "",
      id_empresa: data.empresa.id,
      notificacion: "nuevoTema",
    };

    console.log("despacho", despacho);
    console.log("notificacion", notificacion);

    try {
      // Llamadas asíncronas
      const agregar = await this.despachoService.agregarTemaDespacho(despacho);
      console.log("agregar", agregar);

      this.loadingService.show();

      const notificar = await this.despachoService.nuevoTema(notificacion);
      console.log("notificar", notificar);

      this.loadingService.hide();
      // Validar que no haya errores
      if (!agregar.error && !notificar.error) {
       this.store.dispatch(esNuevoDespacho());
        this.mostrarModalExito();
      } else {
        // Manejo de error si alguna de las operaciones falla
        // this.mostrarModalError(agregar.message || notificar.message);
      }
    } catch (error) {
      this.loadingService.hide();
      console.error("Error al guardar despacho", error);
      // this.mostrarModalError("Ocurrió un error al guardar el despacho.");
    }
  }

  descargaEntregable(entrada: string, entregable: string) {
    this.loadingService.show();
    this.entregablesService
      .descargarEntregable({ entrada, entregable })
      .subscribe((data) => {
        console.log("data", data);
        if (!data.error && !data.data.error) {
          var link = document.createElement("a");
          link.href = data.data;
          link.setAttribute("id", "descargaEntregable");
          link.download = "descargaEntregable";
          link.click();
          window.URL.revokeObjectURL(link.href);

          setTimeout(() => {
            const linkElement = document.getElementById("descargaEntregable");
            if (linkElement) {
              document.body.removeChild(linkElement);
            }
          }, 2000);
          this.loadingService.hide();
        } else {
          const message = data.data.message;
          console.log("message", message);
          this.loadingService.hide();
          this.showModalError("Error", message.mensaje);
        }
      });
  }

  mostrarModalExito() {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: "450px",
      data: {
        title: "Éxito",
        message: "Tema agregado correctamente.",
        showButtons: {
          accept: true,
          cancel: false,
        },
        direction: "end",
        buttonsName: { cancel: "CANCELAR", accept: "ACEPTAR" },
      },
      disableClose: true,
    });

    // Acción cuando el usuario hace clic en "Aceptar"
    dialogRef.componentInstance.confirmAction
      .pipe(take(1)) // Asegura que solo se ejecute una vez
      .subscribe(() => {
        this.nuevoDespacho.reset();
        this.store.dispatch(consultarDespachos());
         // Despacho agregado con éxito
        // Reinicia el formulario
      });
  }

  showModalError(title: string, message: string) {
    this.dialog.open(ConfirmDialogComponent, {
      width: "600px",
      data: {
        title,
        message,
        showButtons: {
          accept: true,
          cancel: false,
        },
        direction: "end",
        buttonsName: { cancel: "CANCELAR", accept: "ACEPTAR" },
      },
    });
  }
  removeEntrada(entrada: any) {
    const entradas = this.nuevoDespacho.get("entradas") as FormControl;
    const filtro = entradas.value.filter(
      (ent: any) => ent.id_entrada !== entrada.id_entrada
    );
    entradas.setValue(filtro);
    this.listaEntradas = [...this.listaEntradas, entrada];
  }

  cancelar() {
    this.store.dispatch(getEntradasByIdEmpresaSuccess({ entradas: [] }));
    this.store.dispatch(esNuevoDespacho());
  }

  cargaCatalogos(): Observable<any> {
    return forkJoin({
      catTipoDespacho: this.loadCatalogosService
        .getCatalogo("TIPO_DESPACHO")
        .pipe(take(1)),
      catEmpresa: this.entradaService.getCatalogo("empresa").pipe(take(1)),
      catCategorizacion: this.loadCatalogosService
        .getCatalogo("categorizacion")
        .pipe(take(1)),
      catCategoria: this.loadCatalogosService
        .getCatalogo("CATEGORIA")
        .pipe(take(1)),
    }).pipe(
      map((result) => {
        const { catTipoDespacho, catEmpresa, catCategorizacion, catCategoria } =
          result;

        const sortedCatEmpresa = sortCatalogo(catEmpresa, "descripcion").filter(
          (cat: any) => cat.activo
        );
        // Aquí puedes transformar el resultado si es necesario
        return {
          catTipoDespacho,
          catEmpresa: sortedCatEmpresa,
          catCategorizacion,
          catCategoria,
        };
      }),
      catchError((error) => {
        console.error("Error en cargaCatalogos:", error);
        return of(null);
      })
    );
  }
}
